<template>
  <div>
    <a-page-header
      :breadcrumb="{ props: { routes:[{path: '/',breadcrumbName: '首页'}
      ,{path:'/website-goods',breadcrumbName:'网站商品列表'}
      ,{path: `/website-goods/${goodsId}$`,breadcrumbName: '网站商品信息'}
      ]}}"
      style="border: 1px solid rgb(235,237,240);background: #ffffff"
      title='商品信息'/>
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['info']" mode="horizontal">
        <a-menu-item key="info">
          <a-icon type="mail"/>
          商品信息
        </a-menu-item>
        <a-menu-item
          key="sku"
          :disabled="!goodsId"
          @click="() => {this.$router.push(`/website-goods/${goodsId}/skus`)}">
          <a-icon type="appstore"/>
          SKU
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px; top:8px">
        <a-button v-if="!goodsId" type="primary" @click="onAdd">创建</a-button>
        <a-button v-if="goodsId" type="primary" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">返回</a-button>
      </a-space>
    </div>
    <div style="margin: 16px">
      <a-spin :spinning="form.loading">
        <a-form-model ref="form" :model="form.data" :rules="form.rules" style="margin-top: 20px">
          <a-row :gutter="20">
            <a-col :span="18">
              <a-card :bordered="false" title="基础信息">
                <a-form-model-item label="商品名称" prop="name">
                  <a-input v-model="form.data.name"/>
                </a-form-model-item>
                <a-form-model-item label="编码" prop="code">
                  <a-input v-model="form.data.code"/>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px" title="图片">
                <a-form-model-item label="封面(385*481)">
                  <div>
                    <cropper-uploader
                      v-model="form.data.coverPath"
                      :imageUrl="form.data.coverPath"
                      :options="coverOptions"
                      avatarTextTop=""
                      avatarTextBottom=""/>
                  </div>
                </a-form-model-item>
                <a-form-model-item label="图集(385*481)">
                  <div class="a-input">
                    <multi-uploader
                      v-model="form.data.images"
                      :options="imagesOptions"/>
                  </div>
                </a-form-model-item>
              </a-card>
              <a-card title="商品尺寸描述" :bordered="false" style="margin-top: 20px">
                <a-form-model-item label="尺寸字典">
                  <a-select v-model="form.data.sizeImage" placeholder="请选择" allowClear>
                    <a-select-option
                      v-for="item in size.data"
                      :key="item.id"
                      :title="item.code"
                      :value="item.code">
                      {{ item.code }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px" title="商品描述">
                <a-form-model-item label="商品描述" prop="description">
                  <a-textarea
                    v-model="form.data.description"
                    :autosize="{minRows: 10}"/>
                </a-form-model-item>
              </a-card>
            </a-col>
            <a-col :span="6">
              <a-card :bordered="false" title="相关信息">
                <a-form-model-item label="系列" prop="seriesId" required>
                  <a-select v-model="form.data.seriesId" placeholder="请选择">
                    <a-select-option
                      v-for="item in series.data "
                      :key="item.id"
                      :title="item.name"
                      :value="item.id"
                      @click="queryCategory(item.id)">
                      {{ item.channel }} - {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="系列下的分类" prop="categoryId" required>
                  <a-select v-model="form.data.categoryId" :allowClear="true" placeholder="先选择系列，再选择分类">
                    <a-select-option
                      v-for="item in category.data.filter(c=> c.seriesId===form.data.seriesId)"
                      :key="item.id"
                      :title="item.name"
                      :value="item.id"
                      @click="queryCategoryName(item.name)">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="集合" prop="gatherId">
                  <a-select v-model="form.data.gatherId" placeholder="请选择">
                    <a-select-option
                      v-for="item in gather.data"
                      :key="item.id"
                      :title="item.name"
                      :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-card>
              <a-card :bordered="false" style="margin-top: 20px">
                <span slot="title">
                  <a-icon style="padding-right: 10px" type="account-book"/>商品状态
                </span>
                <a-form-model-item
                  label="是否上架"
                  prop="status"
                  required>
                  <dict-select
                    v-model="form.data.status"
                    dict-code="GOODS_STATUS"/>
                </a-form-model-item>
                <a-form-model-item
                  v-if="form.data.status === 'PRESELL'"
                  label="上架时间"
                  prop="sellStartAt"
                  required>
                  <a-date-picker
                    v-model="form.data.sellStartAt"
                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                    placeholder=""
                    style="width: 100%"
                    type="datetime"
                    value-format="YYYY-MM-DDTHH:mm:ss">
                  </a-date-picker>
                </a-form-model-item>
              </a-card>

              <a-card :bordered="false" style="margin-top: 20px" title="销售信息">
                <a-form-model-item label="产品最低价格(人民币)" prop="startPrice">
                  <a-input-number
                    v-model="form.data.startPrice"
                    :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="产品最高价格(人民币)" prop="endPrice">
                  <a-input-number
                    v-model="form.data.endPrice"
                    :min="0"/>
                </a-form-model-item>
                <a-form-model-item label="是否男士产品(true/false)" prop="menUse">
                  <a-input v-model="form.data.menUse"/>
                </a-form-model-item>
                <a-form-model-item label="是否限购" prop="isLimited" required>
                  <dict-select
                    v-model="form.data.isLimited"
                    dict-code="SIMPLE_STATUS"/>
                </a-form-model-item>
                <a-form-model-item label="限购数量">
                  <a-input-number
                    v-model="form.data.limitedQuantity"
                    :disabled="form.data.isLimited==='NO'"/>
                </a-form-model-item>
              </a-card>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </div>

    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="video.visible">
      <video
        v-if="video.visible"
        ref="video"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        style="width: 100%;height: auto"
        autoplay
        preload="auto"
        muted="true"
        :src="form.data.inspirationVideo">
        您的浏览器不支持HTML5
      </video>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { _addGoods, _queryGoodsById, _updateGoods, } from '@/api/websiteGoodsApi';
import { _queryCategoryBySeriesId, _querySeriesByType, _queryWebsiteGoodsSeries, } from '@/api/websiteGoodsSeriesApi';
import { _queryGoodsCategories, } from '@/api/websiteGoodsCategoryApi';
import { _queryGoodsGathers, } from '@/api/websiteGoodsGatherApi';
import { _queryAppInfoByType } from '@/api/appInfoApi';
import DictSelect from '../../../components/DictSelect.vue';
import MultiUploader from '../../../components/MultiUploader.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getGoods() {
  const result = await _queryGoodsById(this.goodsId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.nameEn = result.nameEn;
    this.form.data.code = result.code;
    this.form.data.categoryId = result.categoryId;
    this.form.data.seriesId = result.seriesId;
    this.form.data.seriesType = result.seriesType;
    this.form.data.gatherId = result.gatherId;
    this.form.data.coverPath = result.coverPath;
    this.form.data.isLimited = result.isLimited;
    this.form.data.limitedQuantity = result.limitedQuantity;
    this.form.data.status = result.status;
    this.form.data.isPresell = result.isPresell;
    this.form.data.sellStartAt = result.sellStartAt;
    this.form.data.sellEndAt = result.sellEndAt;
    this.form.data.price = result.price;
    this.form.data.sizeImage = result.sizeImage;
    this.form.data.detail = result.detail;
    this.form.data.listPrice = result.listPrice;
    this.form.data.previousPrice = result.previousPrice;
    this.form.data.description = result.description;
    this.form.data.descriptionEn = result.descriptionEn;
    this.form.data.salesQuantity = result.salesQuantity;
    this.form.data.images = result.images ? result.images.split('|') : [];
    this.form.data.type = result.type;
    this.form.data.inspirationVideo = result.inspirationVideo ? result.inspirationVideo.split(',') : [];
    this.form.data.inspirationImg = result.inspirationImg ? result.inspirationImg.split(',') : [];
    this.form.data.content = result.content;
    this.form.data.isVip = result.isVip;
    this.form.data.isNew = result.isNew;
    this.form.data.videoCover = result.videoCover;
    this.form.data.startPrice = result.startPrice;
    this.form.data.endPrice = result.endPrice;
    this.form.data.channel = result.channel;
    this.form.data.material = result.material;
    // 设为 false
    this.form.loading = false;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoods({
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        seriesType: this.form.data.seriesType,
        categoryId: this.form.data.categoryId,
        gatherId: this.form.data.gatherId,
        isLimited: this.form.data.isLimited,
        limitedQuantity: this.form.data.limitedQuantity,
        status: this.form.data.status,
        isPresell: this.form.data.isPresell,
        sellStartAt: this.form.data.sellStartAt,
        sellEndAt: this.form.data.sellEndAt,
        price: this.form.data.price,
        listPrice: this.form.data.listPrice,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        descriptionEn: this.form.data.descriptionEn,
        salesQuantity: this.form.data.salesQuantity,
        images: this.form.data.images.join('|'),
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg.join('|'),
        inspirationVideo: this.form.data.inspirationVideo.join('|'),
        previousPrice: this.form.data.previousPrice,
        content: this.form.data.content,
        isVip: this.form.data.isVip,
        sizeImage: this.form.data.sizeImage,
        videoCover: this.form.data.videoCover,
        vipCategoryId: this.vipCategoryId,
        vipSeriesId: this.vipSeriesId,
        isNew: this.form.data.isNew,
        startPrice: this.form.data.startPrice,
        endPrice: this.form.data.endPrice,
        menUse: JSON.parse(this.form.data.menUse),
        channel: this.form.data.channel,
        material: this.form.data.material,
      });
      if (result) {
        this.$message.success('添加成功');
      }
      if (this.onSubmitHandler) {
        this.onSubmitHandler();
        await this.$router.go(-1);
      } else {
        await this.$router.go(-1);
      }
    }
  });
}

function inSell() {
  this.form.data.status = 'IN_SELL';
  this.onUpdate();
}

function preSell() {
  this.form.data.status = 'PRESELL';
  this.onUpdate();
}

function off() {
  this.form.data.status = 'OFF';
  this.onUpdate();
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      if (this.form.data.status === 'PRESELL') {
        if (this.form.data.sellEndAt) {
          if (this.form.data.sellStartAt === null || this.form.data.sellStartAt === undefined) {
            this.$message.error('上架时间未设置，检查后重新尝试！');
            return;
          }
          if (moment(this.form.data.sellEndAt).valueOf() < moment(this.form.sellStartAt).valueOf()) {
            this.$message.error('下架时间设置不合理，请检查后再操作');
            return;
          }
        }
        // this.$message.error('未设置上架时间，请检查后操作')
      }
      const result = await _updateGoods(this.goodsId, {
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        seriesType: this.form.data.seriesType,
        categoryId: this.form.data.categoryId,
        gatherId: this.form.data.gatherId,
        isLimited: this.form.data.isLimited,
        limitedQuantity: this.form.data.limitedQuantity,
        status: this.form.data.status,
        isPresell: this.form.data.isPresell,
        sellStartAt: this.form.data.sellStartAt,
        sellEndAt: this.form.data.sellEndAt,
        price: this.form.data.price,
        listPrice: this.form.data.listPrice,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        descriptionEn: this.form.data.descriptionEn,
        salesQuantity: this.form.data.salesQuantity,
        images: this.form.data.images.join('|'),
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg.join('|'),
        inspirationVideo: this.form.data.inspirationVideo.join('|'),
        previousPrice: this.form.data.previousPrice,
        content: this.form.data.content,
        isVip: this.form.data.isVip,
        sizeImage: this.form.data.sizeImage,
        videoCover: this.form.data.videoCover,
        vipCategoryId: this.vipCategoryId,
        vipSeriesId: this.vipSeriesId,
        isNew: this.form.data.isNew,
        startPrice: this.form.data.startPrice,
        endPrice: this.form.data.endPrice,
        menUse: JSON.parse(this.form.data.menUse),
        channel: this.form.data.channel,
        material: this.form.data.material,
      });
      if (result) {
        this.$message.success('更新成功');
        this.modified = true;
        this.getGoods();
      }
    }
  });
}

async function onSave() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      if (this.form.data.status === 'PRESELL') {
        if (this.form.data.sellEndAt) {
          if (this.form.data.sellStartAt === null || this.form.data.sellStartAt === undefined) {
            this.$message.error('上架时间未设置，检查后重新尝试！');
            return;
          }
          if (moment(this.form.data.sellEndAt).valueOf() < moment(this.form.sellStartAt).valueOf()) {
            this.$message.error('下架时间设置不合理，请检查后再操作');
            return;
          }
        }
        // this.$message.error('未设置上架时间，请检查后操作')
      }
      await _updateGoods(this.goodsId, {
        name: this.form.data.name,
        nameEn: this.form.data.nameEn,
        code: this.form.data.code,
        seriesId: this.form.data.seriesId,
        seriesType: this.form.data.seriesType,
        categoryId: this.form.data.categoryId,
        gatherId: this.form.data.gatherId,
        isLimited: this.form.data.isLimited,
        limitedQuantity: this.form.data.limitedQuantity,
        status: this.form.data.status,
        isPresell: this.form.data.isPresell,
        sellStartAt: this.form.data.sellStartAt,
        sellEndAt: this.form.data.sellEndAt,
        price: this.form.data.price,
        listPrice: this.form.data.listPrice,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        descriptionEn: this.form.data.descriptionEn,
        salesQuantity: this.form.data.salesQuantity,
        images: this.form.data.images.join('|'),
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg.join('|'),
        inspirationVideo: this.form.data.inspirationVideo.join('|'),
        previousPrice: this.form.data.previousPrice,
        content: this.form.data.content,
        isVip: this.form.data.isVip,
        sizeImage: this.form.data.sizeImage,
        videoCover: this.form.data.videoCover,
        vipCategoryId: this.vipCategoryId,
        vipSeriesId: this.vipSeriesId,
        isNew: this.form.data.isNew,
        startPrice: this.form.data.startPrice,
        endPrice: this.form.data.endPrice,
        channel: this.form.data.channel,
        material: this.form.data.material,
      });

      this.$message.success('保存成功');
      this.getGoods();
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  } else {
    this.$router.go(-1);
  }
}

function reviewVideo() {
  if (this.form.data.inspirationVideo) {
    this.video.visible = true;
  }
}

async function getSeriesList(type) {
  this.series.data = await _querySeriesByType(type);
}

async function queryCategory(seriesId) {
  this.category.data = await _queryCategoryBySeriesId(seriesId);
}

async function queryCategoryName(name) {
  this.categoryName = name;
}

export default {
  name: 'WebsiteGoodsEdit',
  components: { MultiUploader, DictSelect, CropperUploader },
  props: {
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      vipCategoryId: '',
      vipSeriesId: '',
      categoryName: '',
      video: {
        visible: false,
        url: '',
      },
      category: {
        data: [],
      },
      gather: {
        data: [],
      },
      series: {
        data: [],
      },
      size: {
        data: [],
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 385, // 默认生成截图框宽度
        autoCropHeight: 481, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        multi: false,
        serviceType: 'S3',
        title: '修改图片',
      },
      imagesOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 385, // 默认生成截图框宽度
        autoCropHeight: 481, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        multi: true,
        serviceType: 'S3',
        title: '修改图片',
      },
      currencyCode: {
        data: ['EUR', 'USD', 'CNY', 'GBP'],
      },
      modified: false,
      form: {
        loading: false,
        tab: 'IMAGE',
        data: {
          name: '',
          nameEn: '',
          description: '',
          descriptionEn: '',
          code: '',
          isLimited: 'NO',
          limitedQuantity: 0,
          status: 'OFF',
          salesQuantity: 0,
          isPresell: 'NO',
          sellStartAt: `${moment().format('YYYY-MM-DD')}T00:00:00`,
          sellEndAt: `${moment().format('YYYY-MM-DD')}T00:00:00`,
          price: 0,
          previousPrice: 0,
          listPrice: 0,
          type: '',
          categoryId: '',
          gatherId: '',
          seriesId: '',
          seriesType: '',
          content: '',
          coverPath: '',
          images: [],
          inspirationImg: [],
          inspirationVideo: [],
          isVip: 'NO',
          isNew: 'NO',
          sizeImage: '',
          videoCover: '',
          startPrice: '',
          endPrice: '',
          menUse: false,
          // currencyCode: '',
          channel: '',
          material: '',
        },
        title: '',
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          code: [{ required: true, trigger: 'blur' }],
          isLimited: [{ required: true, trigger: 'blur' }],
          status: [{ required: true, trigger: 'blur' }],
          salesQuantity: [{ required: true, trigger: 'blur' }],
          description: [{ required: true, trigger: 'blur' }],
          sellStartAt: [{ required: true, trigger: 'blur' },
            {
              type: 'date', min: moment.now(), message: '选择时间必须大于当前', trigger: 'blur',
            }],
          categoryId: [{ required: true, trigger: 'blur' }],
          seriesId: [{ required: true, trigger: 'blur' }],
          startPrice: [{ required: true, trigger: 'blur' }],
          endPrice: [{ required: true, trigger: 'blur' }],
          // gatherId: [{ required: true, trigger: 'blur' }],
          // channel: [{ required: true, trigger: 'blur' }],
          // currencyCode: [{ required: true, trigger: 'blur' }],
        },
      },

    };
  },
  beforeRouteLeave(to, from, next) {
    console.log(to.name)
    console.log('to.meta.isUseCache:' + !this.modified)
    if (to.name === 'WebsiteGoods') {
      to.meta.isUseCache = !this.modified;
    }
    next();
  },
  methods: {
    getSeriesList,
    moment,
    onAdd,
    onUpdate,
    onSave,
    onCancel,
    getGoods,
    preSell,
    inSell,
    off,
    reviewVideo,
    queryCategory,
    queryCategoryName,
  },
  watch: {
    'form.data.price': {
      handler(val) {
        this.form.data.discount = (val / this.form.data.listPrice * 100 / 100).toFixed(2);
      },
    },
    'form.data.listPrice': {
      handler(val) {
        this.form.data.discount = (this.form.data.price / val * 100 / 100).toFixed(2);
      },
    },
  },
  created: async function () { // 异步加载
    const seriesResult = await _queryWebsiteGoodsSeries({});
    this.series.data = seriesResult.content;
    const categoryResult = await _queryGoodsCategories({});
    this.category.data = categoryResult.content;
    const gatherResult = await _queryGoodsGathers({});
    this.gather.data = gatherResult.content;
    this.size.data = await _queryAppInfoByType({});
    if (this.goodsId) {
      await this.getGoods();
    }
  },
};
</script>

<style scoped>

</style>
